<template>
  <div>
    <div class="nav u-flex">
      <div class="gif">
        <div class="gif-img">
          <img src="@/assets/images/gif/640.gif" alt="gif" />
        </div>
      </div>
      <slot name="gradient" />
    </div>
    <div class="content t-b">
      <p>“十四五”期间优质中小企业培育目标，<span class="t-r">创新型中小企业</span>100万家，<span class="t-r">专精特新</span>10万家，<span class="t-r">专精特新“小巨人”</span>1万家。</p>
      <slot name="content" />
    </div>
    <div class="u-flex u-row-center">
      <div class="btn" @click="handleClick">立即测评</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    pageName: {
      type: String,
      default: 'mastery'
    },
  },
  computed: {
    ...mapGetters('personOptions', ['_isLogin']),
  },
  methods: {
    // 立即测评
    handleClick() {
      this.$emit('handleValidate');
      /* if (this._isLogin) {
        this.$emit('handleValidate');
      } else {
        this.$confirm('尚未登录，请先前往登录', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/login?from=' + this.pageName);
        }).catch(() => {});
      } */
    }
  }
};
</script>

<style lang="scss" scoped>
.nav {
  padding-left: 40px;
  margin-bottom: 24px;
  
  .gif {
    width: 50%;

    &-img {
      width: 400px;
    }
  }
}

.content {
  margin-bottom: 32px;
  text-indent: 2em;
  font-size: 16px;
  line-height: 1.5;
}

.btn {
  background-color: #2c75f8;
  border-radius: 8px;
  font-size: 16px;
  padding: 10px 80px;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: .3s;

  &:hover {
    opacity: .9;
  }

  &:active {
    opacity: 1;
  }
}
</style>